import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider, RequireAuth, useSignOut } from "react-auth-kit";
import UseApplyBodyStyles from "./hookUpdate.js";
import ScrollToTop from "./top.js";
import axiosService from "../Api/axiosService.js";
import UserOnlineStatus from "./userOnlineStatus.js";
import LoginPage from "../jsx/Admin/CRM/Login.js";
import LeadsPage from "../jsx/Admin/CRM/leads.js";
import RecycleBin from "../jsx/Admin/CRM/RecycleBin.jsx";
import EmailQueue from "../jsx/Admin/CRM/EmailQueue.jsx";
import LeadStream from "../jsx/Admin/CRM/LeadStream.jsx";
import DarkModeProvider from "../context/DarkModeContext";
import CallDashboard from "../jsx/Admin/CRM/CallDashboard.jsx";
import Error404 from "../jsx/pages/error/Error404";
import AdminManagementCRM from "../jsx/Admin/CRM/AdminManagement.jsx";
import AIInstructions from "../jsx/Admin/CRM/AIInstructions.jsx";
import PendingCallsQueue from "../jsx/Admin/CRM/PendingCallsQueue.jsx";
import FailedCalls from "../jsx/Admin/CRM/FailedCalls.jsx";
import NoAnswerCalls from "../jsx/Admin/CRM/NoAnswerCalls.jsx";
import CancelledCalls from "../jsx/Admin/CRM/CancelledCalls.jsx";
import CrmProfile from "../jsx/Admin/CRM/Profile.jsx";

function AppRouter() {
  const signOut = useSignOut();

  useEffect(() => {
    const interceptor = axiosService.interceptors.response.use(

      (response) => {
        return response
      },
      (error) => {
        if (error.response?.status === 401 || error.response?.status === 405) {
          signOut();                    // clear react-auth-kit session
          localStorage.removeItem("token");
          localStorage.removeItem("authToken");
          localStorage.removeItem("authUser");
          localStorage.removeItem("auth_state");
          window.location.href = "/auth/login";
        }
        return Promise.reject(error);
      }
    );

    return () => {
      axiosService.interceptors.response.eject(interceptor);
    };
  }, [signOut]);
}
export default function Router() {
  const hostname = window.location.hostname;
  const isLiveDomain =
    hostname === "callmind.tech" || hostname.endsWith(".callmind.tech");

  const cookieDomain = isLiveDomain ? ".callmind.tech" : hostname;

  return (
    <AuthProvider
      authType={"cookie"}
      authName={"_auth"}
      cookieDomain={cookieDomain}
      cookieSecure={window.location.protocol === "https:"}
    >
      <DarkModeProvider>
        <BrowserRouter >
          <UseApplyBodyStyles />
          <ScrollToTop />
          <UserOnlineStatus />
          <AppRouter />
          <Routes>
          <Route index path="/" element={<LoginPage />} />
          <Route path="/auth/login/crm" element={<LoginPage />} />
          <Route path="/auth/login" element={<LoginPage />} />
          <Route
            path="/admin/dashboard/crm"
            element={
              <RequireAuth loginPath={"/auth/login/crm"}>
                <LeadsPage />
              </RequireAuth>
            }
          />
          <Route
            path="/admin/dashboard/crm/recycle-bin"
            element={
              <RequireAuth loginPath={"/auth/login/crm"}>
                <RecycleBin />
              </RequireAuth>
            }
          />
           <Route
            path="/admin/crm/call-dashboard"
            element={
              <RequireAuth loginPath={"/auth/login/crm"}>
                <CallDashboard />
              </RequireAuth>
            }
          />
          <Route
            path="/admin/crm/failed-emails"
            element={
              <RequireAuth loginPath={"/auth/login/crm"}>
                <EmailQueue />
              </RequireAuth>
            }
          />
          <Route
            path="/admin/crm/email-queue"
            element={
              <RequireAuth loginPath={"/auth/login/crm"}>
                <EmailQueue />
              </RequireAuth>
            }
          />
          <Route
            path="/admin/crm/lead/:leadId/stream"
            element={
              <RequireAuth loginPath={"/auth/login/crm"}>
                <LeadStream />
              </RequireAuth>
            }
          />
           <Route
            path="/admin/crm/ai-instructions"
            element={
              <RequireAuth loginPath={"/auth/login/crm"}>
                <AIInstructions />
              </RequireAuth>
            }
          />
           <Route
            path="/admin/crm/admin-management"
            element={
              <RequireAuth loginPath={"/auth/login/crm"}>
                <AdminManagementCRM />
              </RequireAuth>
            }
          />
          <Route
            path="/admin/crm/pending-calls"
            element={
              <RequireAuth loginPath={"/auth/login/crm"}>
                <PendingCallsQueue />
              </RequireAuth>
            }
          />
          <Route
            path="/admin/crm/failed-calls"
            element={
              <RequireAuth loginPath={"/auth/login/crm"}>
                <FailedCalls />
              </RequireAuth>
            }
          />
          <Route
            path="/admin/crm/no-answer-calls"
            element={
              <RequireAuth loginPath={"/auth/login/crm"}>
                <NoAnswerCalls />
              </RequireAuth>
            }
          />
          <Route
            path="/admin/crm/cancelled-calls"
            element={
              <RequireAuth loginPath={"/auth/login/crm"}>
                <CancelledCalls />
              </RequireAuth>
            }
          />
          <Route
            path="/admin/crm/profile"
            element={
              <RequireAuth loginPath={"/auth/login/crm"}>
                <CrmProfile />
              </RequireAuth>
            }
          />
          <Route path="*" element={<Error404 />} />
        </Routes>
      </BrowserRouter>
      </DarkModeProvider>
    </AuthProvider >
  );
}
